module.exports = __webpack_public_path__ + "static/ISO-67bd0880b8de0eb4946006c3be532ad3.png";